import { MenuSeparator } from "@backstage/ui";

import styles from "./SidebarDivider.module.css";

/**
 * A quiet rule separating groups of nav items.
 *
 * Replaces `SidebarDivider` from `@backstage/core-components`. Backstage UI's
 * `MenuSeparator` draws it, so the 1px line tracks the design system's own
 * separator rather than being reinvented here. It still resolves to a real
 * `<hr>` — React Aria's `Separator` defaults to that element — so assistive
 * technology announces the separation without an explicit `role`.
 *
 * Despite the name it carries no menu semantics and reads no menu context: it
 * renders a bare separator, not a `role="menuitem"`. That distinction is why
 * it is safe here when `Menu` and `MenuItem` would not be — those apply the
 * ARIA menu pattern, which strips link semantics from navigation.
 *
 * Two things are overridden in `SidebarDivider.module.css`, both load-bearing:
 * the rule is inset to line up with the rows around it, and coloured close to
 * the rail's own background rather than `--bui-border-1` — see that file for
 * why each matters.
 */
export const SidebarDivider = () => <MenuSeparator className={styles.root} />;
